import { Navigate, useLocation } from 'react-router-dom';
import { userAppContext } from '../../Context/Context';
import { isTrialExpired } from '../../utils/trialUtils';

const UseProtectedRoute = ({ children }) => {
  const { groups, user } = userAppContext();
  const location = useLocation();

  if (groups?.includes('ROLE_TRIAL') && user) {
    const expired = isTrialExpired(user);

    if (expired && location.pathname !== '/plans') {
      return <Navigate to="/plans" replace />;
    }
  }

  return children;
};

export default UseProtectedRoute;
